export const MAX_SCREENSHOT_BYTES = 3 * 1024 * 1024;
export function screenshotError(file: File): string | null {
  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type))
    return 'Choose a PNG, JPEG, or WebP screenshot.';
  if (file.size === 0 || file.size > MAX_SCREENSHOT_BYTES)
    return 'Choose a non-empty screenshot up to 3 MB.';
  return null;
}
